import React, { useMemo } from 'react';
import { isGroupItem } from '@atlassian/jira-business-list-handlers/src/common/utils/hierarchy/index.tsx';
import type { ListViewIssue } from '../../../services/get-list-view-issues/types';
import { useGroupBy } from '../../group-by';
import { GroupItemsController } from '../../with-grouping/group-items';
import { useHierarchyStore } from '../hierarchy-store';
import { useSetChildrenItems } from '../set-children-items';

export const useGroupChildrenLoader = ({ groups }: { groups: ListViewIssue[] }) => {
	const [{ expandedItems }] = useHierarchyStore();
	const [groupByFieldId] = useGroupBy();

	const { setChildrenItems } = useSetChildrenItems();

	const childrenLoader = useMemo(
		() => (
			<GroupItemsController
				expandedGroupItemIssueIds={Object.keys(expandedItems).filter(isGroupItem)}
				groupByFieldId={groupByFieldId}
				onDataChange={setChildrenItems}
				groups={groups}
			/>
		),
		[expandedItems, groupByFieldId, groups, setChildrenItems],
	);

	return {
		childrenLoader,
	};
};
